import { PagenatedResponse } from '@models/common';
import { CreateClassInvoiceData, GetClassInvoiceBody, GetClassInvoiceQuery } from '@models/invoice';
import { ClassReport, CreateClassReportBody } from '@models/report';
import { ClassSchedule } from '@models/schedule';
import { apiClient } from '.';

export const getClassInvoice = async (classInvoiceId: string) => {
  return apiClient.get<GetClassInvoiceBody>(`/partner/v1/class-invoices/${classInvoiceId}`);
};

export const getMyClassInvoices = async (query: GetClassInvoiceQuery) => {
  return apiClient.get<PagenatedResponse<GetClassInvoiceBody>>(`/partner/v1/class-invoices`, {
    params: query,
  });
};

export const createClassInvoice = async (data: CreateClassInvoiceData) => {
  return apiClient.post(`/partner/v1/class-invoices`, data);
};

export const getClassSchedulesByClassInvoiceId = async (classInvoiceId: string) => {
  return apiClient.get<ClassSchedule[]>(`/partner/v1/class-invoices/${classInvoiceId}/schedules`);
};

export const updateClassSchedules = async (props: { classInvoiceId: string; schedules: ClassSchedule[] }) => {
  const { classInvoiceId, schedules } = props;

  return apiClient.put<ClassSchedule[]>(`/partner/v1/class-invoices/${classInvoiceId}/schedules`, schedules);
};

export const updateClassSchedule = async (props: { classInvoiceId: string; schedule: ClassSchedule }) => {
  const { classInvoiceId, schedule } = props;

  return apiClient.put<ClassSchedule[]>(
    `/partner/v1/class-invoices/${classInvoiceId}/schedules/${schedule._id}`,
    schedule,
  );
};

export const getReport = async (classInvoiceId: string) => {
  return apiClient.get<ClassReport>(`/partner/v1/class-invoices/${classInvoiceId}/report`);
};

export const createReport = async (props: { classInvoiceId: string; report: CreateClassReportBody }) => {
  const { classInvoiceId, report } = props;

  return apiClient.post<ClassReport>(`/partner/v1/class-invoices/${classInvoiceId}/report`, report);
};
